<script lang="ts" setup>
import { i18n } from '@apps/main/modules/localization/localizationSetup';

import type { AppSvgIconType } from '@libs/ui';
import { AppSvgIcon } from '@libs/ui';

import { ItinerarySegmentPlaceholderType } from './ItinerarySegmentPlaceholder.model';

interface ItinerarySegmentPlaceholderProps {
  transportType: ItinerarySegmentPlaceholderType;
}

const props = defineProps<ItinerarySegmentPlaceholderProps>();

const { t } = i18n.global;

const options: Record<
  ItinerarySegmentPlaceholderType,
  { label: string; icon: AppSvgIconType }
> = {
  [ItinerarySegmentPlaceholderType.None]: {
    label: `${t('planner.transport.no_transport_selected')}`,
    icon: 'noTransport',
  },
  [ItinerarySegmentPlaceholderType.Flight]: {
    label: `${t('planner.transport.flight')}`,
    icon: 'airplane',
  },
  [ItinerarySegmentPlaceholderType.Ferry]: {
    label: `${t('planner.transport.ferry')}`,
    icon: 'ferry',
  },
  [ItinerarySegmentPlaceholderType.Car]: {
    label: `${t('planner.transport.car')}`,
    icon: 'car',
  },
  [ItinerarySegmentPlaceholderType.Walk]: {
    label: `${t('planner.transport.walking')}`,
    icon: 'personWalking',
  },
  [ItinerarySegmentPlaceholderType.Bicycle]: {
    label: `${t('planner.transport.bicycle')}`,
    icon: 'personBicycling',
  },
  [ItinerarySegmentPlaceholderType.Accommodation]: {
    label: `${t('planner.stays')}`,
    icon: 'bedOutlined',
  },
  [ItinerarySegmentPlaceholderType.Activity]: {
    label: `${t('planner.activities')}`,
    icon: 'activityOutlined',
  },
};
</script>

<template>
  <div class="itinerary-segment-placeholder">
    <AppSvgIcon :name="options[props.transportType].icon" size="18" />
    {{ options[props.transportType].label }}
  </div>
</template>

<style scoped lang="scss">
.itinerary-segment-placeholder {
  display: flex;
  align-items: center;
  gap: var(--spacing-4);
  @include font-label-s-bold;
  border: 1px solid var(--color-neutral-40);
  background-color: var(--color-white);
  border-radius: var(--border-radius-8);
  color: var(--color-neutral-70);
  padding: var(--spacing-8) var(--spacing-12);
}
</style>
